<template>
    <div>
        <div class="row mb-2">
            <div class="col">
                <div class="float-right">
                    <a class="btn btn-primary" :href="newUrl">
                        <i class="fa fa-plus mr-1"></i>Add New Campaign
                    </a>
                </div>
            </div>
        </div>

        <card-spinner style="height: 240px;" v-if="cxCampaigns.loading" />

        <item
            :campaign="campaign"
            v-for="campaign of cxCampaigns.data"
            :key="campaign.id"
            @deleted="fetchCxCampaigns"
            @replicated="fetchCxCampaigns"
        />

        <sms-preview
            ref="smsPreview"
            :campaign="campaign"
        />

        <email-preview
            ref="previewEmail"
            :campaign="campaign"
        />
    </div>
</template>

<script>
    import Item       from './CxCampaignListItem';
    import {mapState} from 'vuex';

    export default {
        components: {Item},

        props: {
            locations: {required: true},
        },

        data() {
            return {
                cxCampaigns: {
                    data : [],
                    links: null,
                    loading: true,
                    meta : null,
                },
                campaign: {}
            }
        },

        computed: {
            ...mapState({
                filter: state => state.filter,
            }),

            newUrl() {
                return this.$laroute.route('campaigns.cx.create');
            }
        },

        watch: {
            filter() {
                this.fetchCxCampaigns();
            },
        },

        created() {
            this.fetchCxCampaigns();
        },

        methods: {
            fetchCxCampaigns() {
                this.loading = true;
                return this.$http.get(this.$laroute.route('api.cx-campaigns.index'), {params: {filter: {...this.filter}}})
                    .then(response => this.cxCampaigns = response.data);
                this.loading = false;
            },

            fetchMessages(campaignId, type = '') {
                return this.$http.get(this.$laroute.route('api.campaign.preview.messages',
                    {
                        campaign: campaignId,
                        type: type
                    }
                ));
            },

            openSmsPreview(campaign) {
                this.fetchMessages(campaign.id)
                    .then(({data}) => {
                        this.campaign = {
                            id       : campaign.id,
                            name     : campaign.name,
                            image    : campaign.image,
                            message  : data.smsMessage,
                            sms_image: data.image
                        };
                    });

                this.$refs.smsPreview.open();
            },

            openEmailPreview(campaign) {
                this.fetchMessages(campaign.id, 'email')
                    .then(({data}) => {
                        this.campaign = {
                            id             : campaign.id,
                            name           : campaign.name,
                            image          : campaign.image,
                            type           : campaign.type,
                            review_sites   : data.reviewSites,
                            default_message: data.defaultMessage,
                            shared_message : data.sharedMessage,
                            message        : data.message,
                            email_image    : data.image
                        };
                    });

                this.$refs.previewEmail.open();
            }
        }
    }
</script>
